import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Alert,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { fetchInterlocutors } from './api'
import { CircularProgress, DialogContent } from '@material-ui/core'
import useRingover from '../../../hooks/useRingover'
import InterlocutorsList from './components/InterlocutorsList'

const Interlocutors = ({
  ticketId,
  setOpenDialogInterlocutors,
  openDialogInterlocutors,
}) => {
  const [selectedPhone, setSelectedPhone] = useState('')
  const [interlocutorSelectedIndex, setInterlocutorSelectedIndex] = useState('')
  const [interlocutors, setInterlocutors] = useState([])
  const [interlocuteur, setInterlocutor] = useState({})
  const [errorMessage, setErrorMessage] = useState('')
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { startCall } = useRingover()

  const closeDialogInterlocutors = () => {
    setOpenDialogInterlocutors(false)
    setSelectedPhone('')
    setErrorMessage('')
  }
  const callInterlocutor = (interlocuteur) => {
    if (validatePhone(interlocuteur)) {
      startCall(interlocuteur?.phone)
      closeDialogInterlocutors()
    } else {
      setErrorMessage(`Le numéro ${interlocuteur?.phone} n’est pas valide`)
    }
  }

  const handleSelectInterlocutor = (
    phone,
    interlocutorSelected,
    interlocuteur
  ) => {
    setInterlocutorSelectedIndex(interlocutorSelected)
    if (validatePhone(interlocuteur)) {
      setSelectedPhone(phone)
      setInterlocutor(interlocuteur)
      setErrorMessage('')
    } else {
      setSelectedPhone('')
      setInterlocutor({})
      setErrorMessage(`Le numéro ${phone} n’est pas valide`)
    }
  }

  const validatePhone = (interlocuteur) => {
    return interlocuteur.isValid
  }

  const fetchInterlocutorsData = async (ticketId) => {
    setErrorMessage('')
    setIsError(false)
    setInterlocutors([])
    setIsLoading(true)
    try {
      const res = await fetchInterlocutors(ticketId)
      if (res.status === 200) {
        setInterlocutors(res.data)
        console.log({ res: res.data, ticketId })
      } else {
        setIsError(true)
        setErrorMessage(
          'Une erreur est survenue lors de la récupération des données.'
        )
      }
    } catch (error) {
      setIsError(true)
      setErrorMessage(
        'Une erreur est survenue lors de la récupération des données.'
      )
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchInterlocutorsData(ticketId)
  }, [ticketId])

  return (
    <Dialog open={openDialogInterlocutors} fullWidth={true} maxWidth={'sm'}>
      <DialogTitle sx={{}}>Sélectionner un interlocuteur</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ p: 2 }}>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <InterlocutorsList
              interlocutors={interlocutors}
              isError={isError}
              interlocutorSelectedIndex={interlocutorSelectedIndex}
              handleSelectInterlocutor={handleSelectInterlocutor}
            />
          )}
          {errorMessage && (
            <Alert severity={isError ? 'error' : 'warning'} sx={{ mt: 2 }}>
              {errorMessage}
            </Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialogInterlocutors}>Fermer</Button>
        <Button
          onClick={() => {
            callInterlocutor(interlocuteur)
          }}
          disabled={!selectedPhone || isLoading}
        >
          Appeler
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Interlocutors
